export const PageHero = ({ eyebrow, title, intro, introSecondary }) => {
  return (
    <section
      className="relative pt-36 pb-20 sm:pt-44 sm:pb-28 border-b border-white/10"
      data-testid="page-hero"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-2">
            <p className="text-[10px] font-sans-modern uppercase tracking-[0.3em] text-white/50">
              {eyebrow}
            </p>
          </div>
          <div className="lg:col-span-10">
            <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-7xl text-white leading-[1.02] tracking-tight">
              {title}
            </h1>
            {intro && (
              <p className="mt-8 max-w-2xl text-base sm:text-lg font-sans-modern font-light text-white/60 leading-relaxed">
                {intro}
              </p>
            )}
            {introSecondary && (
              <p className="mt-6 max-w-2xl text-base sm:text-lg font-sans-modern font-light text-white/60 leading-relaxed">
                {introSecondary}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
